import { TextField, TextFieldProps } from "@shopify/polaris"

import { useKeyEnter } from "../../hooks"
import { RuleItem } from "../../utils"
import { useValidate } from "../global"

export type ProTextFieldProps = Omit<
  TextFieldProps,
  "autoComplete" | "label"
> & {
  /**
   * 校验rules，用法类似antd
   */
  rules?: RuleItem[]
  /**
   * 输入框回车事件
   */
  onPressEnter?(): void
  /**
   * 是否只允许输入正整数
   */
  onlyInt?: boolean
  label?: any
}
const ProTextField = (props: ProTextFieldProps) => {
  const { onPressEnter, onlyInt } = props

  const { error, handleFocus, handleBlur, id, handleChange } = useValidate({
    rules: props.rules,
    value: props.value,
    id: props.id,
    error: props.error,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    onChange(value, id) {
      if (value === "") {
        props.onChange?.("", id)
        return
      }
      if (onlyInt) {
        const maxValue = props.max || Number.MAX_SAFE_INTEGER
        value = value.replace(/[^0-9]/g, "")
        if (!+value) {
          return
        }
        if (value > maxValue) {
          value = maxValue.toString()
        }
        if (props.min && value < props.min) {
          value = props.min.toString()
        }
      }
      props.onChange?.(value, id)
    },
  })

  useKeyEnter({ id, onPressEnter })

  return (
    <TextField
      {...props}
      value={props.value ?? ""}
      id={id}
      autoComplete="off"
      onFocus={handleFocus}
      error={error}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  )
}

export default ProTextField
